import { type ReactNode } from 'react';
import './StatusBanner.css';

type Tone = 'info' | 'success' | 'warning' | 'error';

interface Props {
  tone?: Tone;
  title?: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
}

const ICON: Record<Tone, string> = {
  info: 'i',
  success: '✓',
  warning: '!',
  error: '×',
};

export function StatusBanner({ tone = 'info', title, children, actions }: Props) {
  return (
    <div className={`status-banner status-banner--${tone}`} role="status">
      <span className="status-banner__icon" aria-hidden>
        {ICON[tone]}
      </span>
      <div className="status-banner__content">
        {title && <strong>{title}</strong>}
        {children && <div>{children}</div>}
      </div>
      {actions && <div className="status-banner__actions">{actions}</div>}
    </div>
  );
}
